import moment from "moment";
import React from "react";
import { connect } from "react-redux";

import initialState from "core/reducers/initialState";
import DateTimeUtil from "core/util/DateTimeUtil";
import TokenSession from "core/util/session/TokenSession";


interface IDateLabelOwnProps {
	format?: string;
	relative?: boolean;
	style?: React.CSSProperties;
	value: moment.MomentInput;
	endValue?: moment.MomentInput;
}

interface IDateLabelStateProps {
	language: string;
}

type ResultProps = IDateLabelStateProps & IDateLabelOwnProps;

function mapStateToProps({user}: typeof initialState = initialState): IDateLabelStateProps {
	const language: string = user.language;

	return { language };
}

const DateLabel: React.SFC<ResultProps> = ({endValue, format, language, relative = false, style, value}) => {

	if (!value) {
		return null;
	}

	let dateStr: string = '';

	if (endValue) {
		dateStr = DateTimeUtil.formatDate(value, language, format) + ' - ' + DateTimeUtil.formatDate(endValue, language, DateTimeUtil.isSameDay(value, endValue) ? 'LT' : format);
	} else if (relative) {
		dateStr = DateTimeUtil.fromNow(value, language);
	} else {
		dateStr = DateTimeUtil.formatDate(value, language, format);
	}

	return (
		<span style={style}>
			{dateStr}
		</span>
	);
};

export default connect(mapStateToProps)(DateLabel);



// WEBPACK FOOTER //
// ./src/core/components/label/DateLabel.tsx